import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import axios from 'axios';
import storage from '../utils/storage';
import { showToast } from '../utils/toastActions';
const configOpiton = window && window.config;

const ImportExcel = (props) => {

    const fileInputRef = useRef(null);

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };


    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const validExtensions = ['.xls', '.xlsx'];
            const fileExtension = file.name.split('.').pop();

            if (!validExtensions.includes(`.${fileExtension}`)) {
                showToast('error', 'Error', `Please select a valid Excel file (.xls or .xlsx)`)
                return;
            }

            const selectedFiles = Array.from(event.target.files);
            const formData = new FormData();
            formData.append('file', selectedFiles[0]);
            
            try {
                const response = await axios.post(`${configOpiton?.END_POINT}/communication/v1/${props.url}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': storage.getToken()
                    },
                });
        
                if (response.status === 200) {

                    showToast('success', 'Success', `File uploaded successfully. ${response.data} `)

                    const params = {
                        pageno: 1,
                        pagesize: 10,
                        sort: 'createdOn',
                        sortOrder : -1,
                    }
                    props.handleSearch(params);
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                showToast('error', 'Error', `${error} `)
            }
            fileInputRef.current.value = '';
        }
    };


    return (

        <>
            <input 
                type="file" 
                ref={fileInputRef} 
                style={{ display: 'none' }} 
                onChange={handleFileChange} 
                accept=".xls, .xlsx"
            />
            <Button 
                type="button"
                icon="pi pi-upload" 
                severity="basic" 
                onClick={triggerFileInput} 
                // disabled={!data || data.length === 0}
                label="Import" 
            />
        </>
        
    );
};

export default ImportExcel;
